<template>
	<v-row>
		<v-col>
			<v-data-table
				mobile-breakpoint="0"
				class="backgroundTransparent"
				:headers="headers"
				:items="notificationConfigurations"
				:items-per-page="5"
				loading-text="Cargando..."
				no-data-text="Sin notificaciones"
				:footer-props="{
					'items-per-page-text': 'Notificaciones por página',
				}"
			>
				<template v-slot:top>
					<div class="text-left primary--text subtitle-2">Notificaciones Programadas</div>
				</template>
				<!-- <template v-slot:[`item.excludedRecipients`]="{ item }">
					<v-btn
						text
						color="primary"
						small
						@click="handleExcludedSelection(item)"
						:id="item._id"
					>
						Ver excluidos
					</v-btn>
				</template> -->
				<template v-slot:[`item.actions`]="{ item }">
					<v-btn text color="primary" @click="deleteItem(item)" :loading="loading">
						Borrar
					</v-btn>
				</template>
			</v-data-table>
			<!-- <ExcludedPersons
				v-if="excludedPersonsModal"
				:set-excluded-persons-modal="setExcludedPersonsModal"
				:excluded-persons-modal="excludedPersonsModal"
				:excluded-persons="selectedNotificationConfig.excludedRecipients"
				:place-id="placeId"
				:notification-config-id="selectedNotificationConfig._id"
			/> -->
		</v-col>
	</v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import ExcludedPersons from '@/components/notifications/ExcludedPersons';
export default {
	// components: { ExcludedPersons },
	props: {
		placeId: { type: String, required: true },
	},
	computed: {
		notificationConfigurations() {
			if (this.places) {
				const place = this.places.find(item => item.value == this.placeId);
				const notifications = place.notificationConfigurations
					? place.notificationConfigurations
					: [];
				return notifications;
			}
			return [];
		},

		...mapGetters({
			persons: 'Person/persons',
			places: 'Lodging/places',
			selectedNotificationConfig: 'Lodging/selectedNotificationConfig',
		}),
	},
	data() {
		return {
			headers: [
				{ text: 'Fecha', value: 'selectedDay', sortable: false },
				{ text: 'Tipo', value: 'type', sortable: false },
				// { text: 'Destinatarios Excluidos', value: 'excludedRecipients', sortable: false },
				{ text: 'Hora', value: 'hour', sortable: false },
				{ text: 'Acción', value: 'actions', sortable: false },
			],
			// excludedPersonsModal: false,
			loading: false,
		};
	},
	methods: {
		async deleteItem(item) {
			this.setLoading(true);
			await this.deleteNotificationConfig({
				placeId: this.placeId,
				notificationConfigId: item._id,
			});
			this.setLoading(false);
		},
		// handleExcludedSelection(selectedNotificationConfig) {
		// 	this.setSelectedNotificationConfig(selectedNotificationConfig);
		// 	this.setExcludedPersonsModal(true);
		// },
		// setExcludedPersonsModal(value) {
		// 	this.excludedPersonsModal = value;
		// },
		setLoading(value) {
			this.loading = value;
		},
		// ...mapMutations({
		// 	setSelectedNotificationConfig: 'Lodging/setSelectedNotificationConfig',
		// }),
		...mapActions({
			deleteNotificationConfig: 'Lodging/deleteNotificationConfig',
		}),
	},
};
</script>
